<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
========================================================================================== -->

<template>
  <div id="app" :class="vueAppClasses">
    <router-view
      v-if="isAuthenticated && hasLoadedData"
      @setAppClasses="setAppClasses"
    />
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import router from "./router";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      vueAppClasses: [],
      hasLoadedData: false,
    };
  },
  watch: {
    "$store.state.themeProps.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "users/isAuthenticated",
      activeVenue: "venues/activeVenue",
    }),
  },
  methods: {
    async awaitAuth() {
      this.$vs.loading();
      setTimeout(async () => {
        const authStatus = localStorage.getItem("rekom.life.isAuthed");
        if (authStatus && authStatus === "true") await this.loadRequiredData()
        else await this.awaitAuth();
      }, 200)
    },
    async loadRequiredData() {
      await this.$store.dispatch("cockpitReports/getCockpitReports");
      await this.$store.dispatch("venues/ensureUserVenues");
      await this.$store.dispatch("users/ensureMe");
      this.hasLoadedData = true;
      this.$vs.loading.close();
    },
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  async mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    await this.awaitAuth();
  },

  async created() {
    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);

    /*
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          console.log("Dispatch logout")
          this.$store.dispatch(logout)
        }
        throw err;
      });
    });
  */
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped></style>
